import { IcurrentLanguage, IRootState } from '../types/IRootState';
import VueI18n from 'vue-i18n';

const languageMutations = {
    toggleLanguage(state: IRootState, languageName: string) {
        state.activeLanguages.map((languageFound: IcurrentLanguage) => {languageFound.value = false; return languageFound; });
        const language = state.activeLanguages.find((languageFound: IcurrentLanguage) => languageFound.name === languageName);
        if (language !== undefined) { language.value = !language.value; }
        state.globalLanguage = languageName;
    },
    setGlobalLanguage(state: IRootState, language: string) {
        state.globalLanguage = language.toLowerCase().substr(0, 2);
    },
    setActiveLanguages(state: any) {

        state.activeLanguages = [
            { name: 'pt', value: false },
            { name: 'en', value: false },
            { name: 'es', value: false }];
        state.activeLanguages
            .find((currentLanguage: IcurrentLanguage) => currentLanguage.name.toLowerCase().substr(0, 2) === state.globalLanguage)
            .value = true;
    },
};

export default languageMutations;
